import { rx } from '@code-expert/fp-ts-rxjs';
import { flow3, tagged } from '@code-expert/prelude';
import { aggregateOptionalSingleton, aggregatePublicationSet, aggregateSingleton, aggregateTrigger, } from '@code-expert/pubsub-common';
import { useObservable } from '@code-expert/react';
import { toObservable } from './toObservable.js';
import { useTrigger } from './trigger.js';
const getCount = (e) => tagged.value(e);
const methodologies = {
    find: flow3(toObservable, aggregatePublicationSet()),
    findOne: flow3(toObservable, aggregateOptionalSingleton()),
    getOne: flow3(toObservable, aggregateSingleton()),
    trigger: flow3(toObservable, aggregateTrigger()),
    count: flow3(toObservable, rx.map(getCount)),
};
export const makeUsePublication = (socket) => {
    // DO NOT INLINE - we need an assignment to a variable for it to have a `name` property
    const usePublication = (name, ...[opts]) => {
        const method = opts?.method ?? 'find';
        const methodology = methodologies[method];
        const getObservable = methodology(socket)(name);
        /* eslint-disable react-hooks/rules-of-hooks */
        return (method === 'trigger'
            ? useTrigger(useObservable(getObservable, opts))
            : useObservable(getObservable, opts));
        /* eslint-enable react-hooks/rules-of-hooks */
    };
    return usePublication;
};
//# sourceMappingURL=usePublication.js.map